import { ButtonHTMLAttributes, ComponentClass, createElement, forwardRef, FunctionComponent, NamedExoticComponent } from "react";
import classNames from "classnames";
import { RefType } from "../../../types";
import { genericMemo } from "../../../utils";

import styles from "./style.module.scss";

export type BaseButtonProps<P extends object = ButtonHTMLAttributes<HTMLButtonElement>, R extends unknown = HTMLButtonElement> = {
  component?: string | FunctionComponent<P> | ComponentClass<P, any> | NamedExoticComponent<P>,
  ref?: RefType<R>,
  className?: string,
  buttonType?: "primary" | "secondary" | "round";
  buttonAlign?: "left" | "center" | "right";
  buttonColorSchema?: "default" | "outlined" | "light" | "outlined-light" | "outlined-mistake";
  disabled?: boolean;
}

export type ButtonProps<P extends object = ButtonHTMLAttributes<HTMLButtonElement>, R extends unknown = HTMLButtonElement> =
  BaseButtonProps<P, R> & P;

const ButtonComponent = <P extends object = ButtonHTMLAttributes<HTMLButtonElement>, R extends unknown = HTMLButtonElement>(props: ButtonProps<P, R>) => <></>;
type ButtonComponentType = typeof ButtonComponent;

export const Button = genericMemo(forwardRef(<P extends object = ButtonHTMLAttributes<HTMLButtonElement>, R extends unknown = HTMLButtonElement>(
  {
    component = "button",
    disabled = false,
    buttonType = "primary",
    buttonAlign = "center",
    buttonColorSchema = "outlined",
    className,
    ...props
  }: ButtonProps<P, R>,
  ref: RefType<R>,
) => {
  return createElement(component as any, {
    ref,
    disabled,
    className: classNames(
      className,
      styles.root,
      styles[buttonType as any],
      styles[buttonAlign as any],
      styles[buttonColorSchema as any],
      {
        [styles.disabled]: disabled,
      },
    ),
    ...props,
  });
}) as ButtonComponentType);

export default Button;
